<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export interface Props {
  title: string;
  isCompleted?: boolean;
  icon?: string;
  color?: string;
}

withDefaults(defineProps<Props>(), {
  isCompleted: false,
  icon: 'spinner',
  color: 'blue',
});
</script>

<template>
  <div class="bg-blue-50 flex flex-col gap-4 w-full p-6 text-center rounded-xl grow">
    <h3 class="text-base grow">{{ title }}</h3>
    <FontAwesomeIcon
      :icon="isCompleted ? ['fas', 'check'] : ['fad', icon]"
      class="text-5xl"
      :class="{
        'text-green-700': isCompleted,
        'animate-spin': icon === 'spinner' && !isCompleted,
        'fa-gray': color === 'gray',
      }"
    />
    <slot>
      <span
        data-test-id="status-card-fallback-content"
        class="text-xs w-fit py-1 px-3 rounded-full mx-auto font-medium"
        :class="isCompleted ? 'bg-green-100 text-green-1000' : 'bg-orange-100 text-orange-1000'"
      >
        {{ isCompleted ? 'Succesvol' : 'In behandeling' }}
      </span>
    </slot>
  </div>
</template>
